import { useQuery } from '@tanstack/react-query';
import {
  fetchSparklineDataByContratoIds,
  type ContratoSparklineData,
} from '../services/ifDataService';

export type { ContratoSparklineData };

export function useIFSparklineData(contratoIds: string[]) {
  return useQuery({
    queryKey: ['if-sparkline-data', contratoIds],
    queryFn: () => fetchSparklineDataByContratoIds(contratoIds),
    enabled: contratoIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
